import ModalCustom from '../common/Modal/ModalCustom'
import { Table, Button } from 'antd'
import { DeleteOutlined } from '@ant-design/icons'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import {
  deleteItemNotification,
  notificationList
} from '../../services/projectRecommendservice'
import { useEffect, useState } from 'react'
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import get from 'lodash.get'
import openNotification from '../common/Notification/openNotification '
import dayjs from 'dayjs'
const ModalNotification = ({ data, isModalOpen, onClose, onConfirm }) => {
  const [dataNotification, setDataNotification] = useState([])
  const [loading, setLoading] = useState(false)
  const columns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt'
    },
    {
      title: 'Dự Án',
      dataIndex: 'project',
      key: 'project',
      render: (text) => data.name || '-'
    },
    {
      title: 'Họ và tên',
      dataIndex: 'customer_name',
      key: 'customer_name',
      render: (text) => text || '-' // Hiển thị "-" nếu không có dữ liệu
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'customer_phone',
      key: 'customer_phone',
      render: (text) => text || '-'
    },
    {
      title: 'Email',
      dataIndex: 'customer_email',
      key: 'customer_email',
      render: (text) => text || '-'
    },
    {
      title: 'Ngày đăng ký',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (text) => {
        return text ? dayjs(text).format('DD/MM/YYYY') : '-'
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button
          style={{ width: 32 }}
          icon={<DeleteOutlined style={{ color: 'red' }} />}
          onClick={() =>
            showConfirm({
              title: 'Xác nhận xoá',
              content: (
                <div>
                  Bạn có chắc chắn muốn xoá
                  <b> {record.customer_name}</b> không?
                </div>
              ),
              onOk: () => handleDelete(record.id)
            })
          }
        />
      )
    }
  ]

  useEffect(() => {
    if (data?.id) {
      getListNotification(data?.id)
    }
  }, [data?.id])

  // danh sách nhận thông báo
  const getListNotification = async (id) => {
    setLoading(true)
    try {
      const res = await notificationList(id) // Assuming roleSearch is an API function
      if (res?.data?.list) {
        const formattedData = res?.data?.list?.map((item, index) => ({
          ...item,
          stt: index + 1
        }))

        setDataNotification(formattedData)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      console.error('Error fetching roles:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (ids) => {
    const body = {
      ids: [ids]
    }
    try {
      const res = await deleteItemNotification(body || [])
      if (res?.data == 1) {
        openNotification('success', 'Xoá thành công')
        getListNotification(data?.id)
      } else {
        openNotification('error', 'Có lỗi xảy ra, Vui lòng thử lại')
      }
    } catch (err) {
      console.error('Error creating product:', err)
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    }
  }
  const headerMap = {
    project: 'Dự án',
    customer_name: 'Họ và tên',
    customer_phone: 'Số điện thoại',
    customer_email: 'Email',
    created_at: 'Ngày đăng ký'
  }
  const exportToExcel = () => {
    // Chuyển đổi dataSource thành format mới
    const formattedData = dataNotification?.map((item) => {
      return {
        [headerMap.project]: data.name,
        [headerMap.customer_name]: item.customer_name,
        [headerMap.customer_phone]: item.customer_phone,
        [headerMap.customer_email]: item.customer_email,
        [headerMap.created_at]: item.created_at
          ? dayjs(item.created_at).format('DD/MM/YYYY')
          : '-'
      }
    })

    const ws = XLSX.utils.json_to_sheet(formattedData)
    // Định nghĩa độ rộng của từng cột
    ws['!cols'] = [
      { wch: 30 }, // Độ rộng cột Project
      { wch: 30 }, // Độ rộng cột Customer Name
      { wch: 15 }, // Độ rộng cột Customer Phone
      { wch: 25 }, // Độ rộng cột Customer Email
      { wch: 15 } // Độ rộng cột Created At
    ]
    // Đổi tên tiêu đề cột
    XLSX.utils.sheet_add_aoa(
      ws,
      [
        [
          headerMap.project,
          headerMap.customer_name,
          headerMap.customer_phone,
          headerMap.customer_email,
          headerMap.created_at
        ]
      ],
      { origin: 'A1' }
    )

    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, 'Danh sách')

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
    const dataEx = new Blob([excelBuffer], { type: 'application/octet-stream' })
    saveAs(dataEx, 'danh_sach_nhan_thong_bao.xlsx')
  }

  return (
    <>
      <ModalCustom
        title="Danh sách nhận thông báo"
        visible={isModalOpen}
        centered
        width={1000}
        onCancel={() => {
          onClose()
        }}
        cancelText="Đóng"
        footer={''}
      >
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            onClick={exportToExcel}
            style={{ marginBottom: 16 }}
          >
            Xuất Excel
          </Button>
        </div>
        <Table
          loading={loading}
          columns={columns}
          dataSource={dataNotification || []}
          pagination={{ pageSize: 5 }}
        />
      </ModalCustom>
      <ModalConfirm />
    </>
  )
}
export default ModalNotification
